import { render, staticRenderFns } from "./RegisterPallet.vue?vue&type=template&id=054962cf"
import script from "./RegisterPallet.vue?vue&type=script&lang=js"
export * from "./RegisterPallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports